import { FC } from 'react';
import { IRecording } from '../../recording/RecordingState';
import { BulletList } from '../view-note/ViewNoteSection';

export const AIParticipants: FC<{ recording: IRecording; }> = ({ recording }) => {
    return recording?.summary?.participants && (
        <BulletList heading="Participants" items={recording.summary.participants} />
    );
};
